import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Divider, Form, Grid, Header, List, Table } from 'semantic-ui-react'
import Section from '../Inputs/Section'
import Checkbox from '../Inputs/Checkbox'
import Input from '../Inputs/Input'
import { observer } from 'mobx-react'
import TableDnD from '../Inputs/TableDnD'

@observer
class RIANVC000 extends Component {
  static propTypes = {
    equipment: PropTypes.instanceOf(FormEntry)
  }

  render () {
    const { equipment } = this.props
    return (
      <Form>
        <Section title={(<Header as='h2'>RAPPORT D'INSPECTION SYSTÈME AU GAZ</Header>)}>
          <Grid>
            <Grid.Row columns='equal'>
              <Grid.Column verticalAlign='middle'>Type d'inspection</Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_annuelle' formEntry={equipment} label='Annuelle' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_semiAnnuelle' formEntry={equipment} label='Semi annuelle' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_trimestrielle' formEntry={equipment} label='Trimestrielle' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_mensuelle' formEntry={equipment} label='Mensuelle' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_hebdomadaire' formEntry={equipment} label='Hebdomadaire' /></Grid.Column>
              <Grid.Column><Input name='typeInspection_other' formEntry={equipment} label='Autre' /></Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column verticalAlign='middle'>Voir note au rapport</Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_note_yes' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_note_no' formEntry={equipment} label='Non' /></Grid.Column>
              <Grid.Column verticalAlign='middle'>Photos d'expertise au dossier?</Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_photo_yes' formEntry={equipment} label='Oui' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='typeInspection_photo_no' formEntry={equipment} label='Non' /></Grid.Column>
              <Grid.Column />
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-1.0  Rapport annuel de mise à l'essai et d'inspection</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>La documentation du réseau avertisseur d'incendie est sur place et comporte une description du réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}>Le réseau surveillé est complètement en état de fonctionner</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Le réseau avertisseur d'incendie présente des lacunes décrites sur les pages ci-jointes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={7}>Une copie du présent rapport sera remise à la personne suivante; propriétaire ou représentant du propriétaire de ce bâtiment</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_yes_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_na_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_no_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_0_note_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={15}><Input name='rapport_1_0_name_e' formEntry={equipment} label='Nom' /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-1.1 Panneau de relâche</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>Le panneau de relâche est relié au panneau d'alarme incendie?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}>Panneau d'alarme incendie</Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_1_marque_b' formEntry={equipment} label='Marque' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_1_modele_b' formEntry={equipment} label='Modèle' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Le panneau d'alarme incendie a été contourné?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={7}>Le panneau de relâche a été remis en fonction?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_yes_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_na_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_no_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_1_note_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-1.2 Supervision des systèmes</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>Le réseau est-il supervisé par un organisme extérieur?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}><Input name='rapport_1_2_nom_b' formEntry={equipment} label="Nom de l'organisme de supervision" /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_tel_b' formEntry={equipment} label='Téléphone' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_sysNo_b' formEntry={equipment} label='Syst. no' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Est-ce que l'organisme externe de supervision a été avisé du début des travaux?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={7}>Nom du propriétaire ou son représentant</Grid.Column>
              <Grid.Column width={8}><Input name='rapport_1_2_nom_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={7}><Input name='rapport_1_2_nom_e' formEntry={equipment} label="No d'identification de la personne avisée" /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_date_e' formEntry={equipment} label='Date' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_heure_e' formEntry={equipment} label='Heure' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={7}>Le panneau d'alarme incendie a été remis en fonction?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_yes_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_na_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_no_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_note_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={7}>Est-ce que l'organisme externe de supervision a été avisé de la fin des travaux?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_yes_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_na_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_no_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_1_2_note_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={7}><Input name='rapport_1_2_nom_h' formEntry={equipment} label="No d'identification de la personne avisée" /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_date_h' formEntry={equipment} label='Date' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_1_2_heure_h' formEntry={equipment} label='Heure' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={15}><Input name='rapport_1_2_notes_i' formEntry={equipment} label='Commentaires' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={7}>Désactivation</Grid.Column>
              <Grid.Column width={8}>
                <Input name='rapport_1_2_signalisation_j' formEntry={equipment} label='Signalisation' />
                <Input name='rapport_1_2_date_j' formEntry={equipment} label='Auxiliaires' />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.0 Fiche d'essai du poste de contrôle ou du répondeur (légende)</Header>)}>
          <p><strong>Oui = Essai réussi, N/A = Non applicable, Non = Essai non réussi</strong></p>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.1  Mise à l'essai du poste de contrôle ou du répondeur <small>(Ref. art. 5.1.3, 5.2.2.1)</small></Header>)}>
          <Form.Group widths='equal'>
            <Input name='rapport_2_1_emplacement' formEntry={equipment} label='Emplacement du poste de contrôle ou du répondeur' />
            <Input name='rapport_2_1_identification' formEntry={equipment} label='Identification du poste de contrôle ou du répondeur' />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de l'indicateur visuel de mise sous tension</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du signal de défectuosité visuel commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du signal de défectuosité sonore commun</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de l'interrupteur de signalisation sonore de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du signal de défectuosité de l'alimentation principale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={7}>Fuite à la terre sur signal de défectuosité positif et négatif</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du signal d'alerte (pré-signal)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du signal d'alarme (générale)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du passage automatique de signal d'alerte à signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du passage manuel de signal d'alerte à signal d'alarme</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>K</Grid.Column>
              <Grid.Column width={7}>Caractéristique (accusé de réception) d'annulation du passage automatique de signal d'alerte à signal d'alarme fonctionnant sur un réseau à deux étapes</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>L</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de la désactivation de l'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>M</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de l'interruption manuelle du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>N</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de l'indicateur visuel d'interruption du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_n' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>O</Grid.Column>
              <Grid.Column width={7}>Déclenchement automatique du signal d'alarme sonore, après interruption, en cas de réception d'alarme subséquente</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P</Grid.Column>
              <Grid.Column width={4}>Temporisation automatique d'annulation du signal d'alarme sonore</Grid.Column>
              <Grid.Column width={3}><Input name='rapport_2_1_h_p' formEntry={equipment} label='H' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_p' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_p' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Q</Grid.Column>
              <Grid.Column width={7}>Signaux d'alerte et d'alarme sonores et visuels programmés et fonctionnant conformément à la conception et aux spécifications; documentation décrite à l'annexe C, Description du mode opératoire d'inspection et de mise à l'essai du réseau avertisseur d'incendie.</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_q' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>R</Grid.Column>
              <Grid.Column width={7}>Fonctionnement d'alarme et de surveillance du circuit d'entrée, y compris les indications sonores et visuelles</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_r' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>S</Grid.Column>
              <Grid.Column width={7}>La surveillance des défauts sur un circuit d'entrée entraîne une indication de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>T</Grid.Column>
              <Grid.Column width={7}>Fonctionnement des indicateurs d'alarme du circuit de sortie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>U</Grid.Column>
              <Grid.Column width={7}>La surveillance des défauts sur un circuit de sortie entraîne une indication de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>V</Grid.Column>
              <Grid.Column width={7}>Essai d'indicateur visuel (essai de lampe)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_v' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_v' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>W</Grid.Column>
              <Grid.Column width={7}>Séquences de signal codé fonctionnant au moins le nombre de fois nécessaire et suivies d'un déclenchement de signal d'alarme approprié</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_w' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_w' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>X</Grid.Column>
              <Grid.Column width={7}>Séquences de signal codé non-interrompues par une alarme subséquente</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_x' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_x' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Y</Grid.Column>
              <Grid.Column width={7}>Une dérivation du dispositif auxiliaire provoquant un signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_y' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_y' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Z</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du circuit d'entrée vers le circuit de sortie, y compris les circuits des dispositifs auxiliaires pour assurer le bon fonctionnement du programme, selon la conception et les spécifications; documentation décrite à l'annexe C, Description du mode opératoire d'inspection et de mise à l'essai du réseau avertisseur d'incendie.</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_z' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_z' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>AA</Grid.Column>
              <Grid.Column width={7}>Fonctionnement du réarmement du réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_aa' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_aa' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>BB</Grid.Column>
              <Grid.Column width={7}>Fonctionnement de la commutation de l'alimentation principale à l'alimentation de secours</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_bb' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_bb' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>CC</Grid.Column>
              <Grid.Column width={7}>Vérification de la confirmation du changement d'état (détecteurs de fumée seulement). Se reporter au paragraphe 5.7.4.3, Confirmation de changement d'état (fonction de vérification d'alarme)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_cc' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_cc' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>DD</Grid.Column>
              <Grid.Column width={7}>Réception de la transmission d'un signal d'alarme à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_dd' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_dd' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>EE</Grid.Column>
              <Grid.Column width={7}>Réception de la transmission d'un signal de surveillance à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_ee' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_ee' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>FF</Grid.Column>
              <Grid.Column width={7}>Réception de la transmission d'un signal de défectuosité à la c entrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_ff' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_ff' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_ff' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_ff' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>GG</Grid.Column>
              <Grid.Column width={7}>Se reporter à la section GAZ 1.2</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_gg' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_gg' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_gg' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_gg' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>HH</Grid.Column>
              <Grid.Column width={7}>Le déclenchement du sectionneur de la centrale de réception d'alarme incendie produit une indication de défectuosité précise au poste de contrôle ou au répondeur et achemine un signal de défectuosité à la centrale de réception d'alarme incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_yes_hh' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_na_hh' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_no_hh' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_1_note_hh' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.2 Inspection de l'alimentation  <small>(Ref. art. 5.1.3, 5.3.1)</small></Header>)}>
          <Form.Group widths='equal'>
            <Input name='rapport_2_2_emplacement' formEntry={equipment} label='Emplacement du poste de contrôle ou du répondeur' />
            <Input name='rapport_2_2_identification' formEntry={equipment} label='Identification du poste de contrôle ou du répondeur' />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>Protection fusible correspondant aux caractéristiques nominales affichées par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}>Alimentation suffisante pour les besoins du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Alimentation 120vac servant au panneau d'incendie seulement</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={2}>Disjoncteur bien identifié et verrouillé</Grid.Column>
              <Grid.Column width={5}>
                <Form.Group widths='equal'>
                  <Input name='rapport_2_2_id_d' formEntry={equipment} label='ID' />
                  <Input name='rapport_2_2_ct_d' formEntry={equipment} label='CT' />
                </Form.Group>
              </Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_yes_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_na_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_no_d' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_note_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={7}><Input name='rapport_2_2_emplacement_e' formEntry={equipment} label='Emplacement du panneau électrique' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_yes_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_na_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_no_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_2_note_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.3 Mise à l'essai et inspection de l'alimentation de secours <small>(Ref. art. 5.1.3, 5.3.2, 5.3.3)</small></Header>)}>
          <Form.Group widths='equal'>
            <Input name='rapport_2_3_emplacement' formEntry={equipment} label='Emplacement du poste de contrôle ou du répondeur' />
            <Input name='rapport_2_3_identification' formEntry={equipment} label='Identification du poste de contrôle ou du répondeur' />
          </Form.Group>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>A</Grid.Column>
              <Grid.Column width={7}>Type de batteries recommandé par le fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>B</Grid.Column>
              <Grid.Column width={7}>Caractéristiques nominales suffisantes d'après les calculs fondés sur la pleine charge du réseau</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>C</Grid.Column>
              <Grid.Column width={7}>Tension de batterie lorsque la source d'alimentation principale est sous tension</Grid.Column>
              <Grid.Column width={4}><Input name='rapport_2_3_tension_c' formEntry={equipment} label='Tension' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_2_3_vcc_c' formEntry={equipment} label='V.c.c.' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>D</Grid.Column>
              <Grid.Column width={7}>Tension et courant de batterie, alimentation principale coupée et réseau avertisseur d'incendie en mode de surveillance</Grid.Column>
              <Grid.Column width={4}>
                <Input name='rapport_2_3_tension_d' formEntry={equipment} label='Tension' />
                <Input name='rapport_2_3_courant_d' formEntry={equipment} label='Courant' />
              </Grid.Column>
              <Grid.Column width={4}>
                <Input name='rapport_2_3_vcc_d' formEntry={equipment} label='V.c.c.' />
                <Input name='rapport_2_3_ma_d' formEntry={equipment} label='MA' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>E</Grid.Column>
              <Grid.Column width={7}>Tension et courant de batterie, alimentation principale coupée et réseau avertisseur d'incendie en pleine charge d'alarme</Grid.Column>
              <Grid.Column width={4}>
                <Input name='rapport_2_3_tension_e' formEntry={equipment} label='Tension' />
                <Input name='rapport_2_3_courant_e' formEntry={equipment} label='Courant' />
              </Grid.Column>
              <Grid.Column width={4}>
                <Input name='rapport_2_3_vcc_e' formEntry={equipment} label='V.c.c.' />
                <Input name='rapport_2_3_ma_e' formEntry={equipment} label='MA' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>F</Grid.Column>
              <Grid.Column width={7}>Courant de charge</Grid.Column>
              <Grid.Column width={4}><Input name='rapport_2_3_courant_f' formEntry={equipment} label='Courant' /></Grid.Column>
              <Grid.Column width={4}><Input name='rapport_2_3_ma_f' formEntry={equipment} label='MA' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>G</Grid.Column>
              <Grid.Column width={7}>Recherche de dommages matériels</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>H</Grid.Column>
              <Grid.Column width={7}>Bornes nettoyées et lubrifiées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>I</Grid.Column>
              <Grid.Column width={7}>Bornes serrées</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_i' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_i' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>J</Grid.Column>
              <Grid.Column width={7}>Niveau d'électrolyte correct</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_j' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_j' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>K</Grid.Column>
              <Grid.Column width={7}>Densité de l'électrolyte conforme aux spécifications du fabricant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_k' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_k' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>L</Grid.Column>
              <Grid.Column width={7}>Aucune fuite d'électrolyte</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_l' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_l' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>M</Grid.Column>
              <Grid.Column width={7}>Ventilation adéquate</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_m' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_m' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>N</Grid.Column>
              <Grid.Column width={7}>Code dateur du fabricant ou date de mise en service</Grid.Column>
              <Grid.Column width={6}><Input name='rapport_2_3_date_n' formEntry={equipment} label='Date' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_n' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>O</Grid.Column>
              <Grid.Column width={7}>Débranchement provoque signal de défectuosité</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_o' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_o' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P</Grid.Column>
              <Grid.Column width={7}>Indiquer le type d'essai de batterie exécuté</Grid.Column>
              <Grid.Column width={6}><Input name='rapport_2_3_test_p1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p1' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P (I)</Grid.Column>
              <Grid.Column width={7}>Vérification au moyen d'un essai démontrant qu'elle fournit la charge de surveillance nécessaire pendant 24 heures, suivie d'un essai démontrant qu'elle fournit le courant de pleine charge nécessaire</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p2' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>
                <Form.Group widths='equal'>
                  <Input name='rapport_2_3_alarm_p3' formEntry={equipment} label='Débranché alarme' />
                  <Input name='rapport_2_3_heure_p3' formEntry={equipment} label='Heure' />
                  <Input name='rapport_2_3_minute_p3' formEntry={equipment} label='Minute' />
                </Form.Group>
              </Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p3' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P (II)</Grid.Column>
              <Grid.Column width={7}>Essai silencieux exécuté au moyen de la méthode de résistance de charge pour réaliser l'essai pleine durée</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p4' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P (III)</Grid.Column>
              <Grid.Column width={7}>Essai silencieux accéléré</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p5' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P (IV)</Grid.Column>
              <Grid.Column width={7}>Essai de capacimètre de batterie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p6' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>P (V)</Grid.Column>
              <Grid.Column width={7}>Au lieu d'exécuter les essais décrits ci-dessus, remplacer la batterie par un type de batterie recommandé par le fabricant, doté d'un code dateur courant et d'une capacité nominale en ampère-heure</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_p7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_p7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_p7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_p7' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>Q</Grid.Column>
              <Grid.Column width={7}>Consigner la capacité de la batterie calculée</Grid.Column>
              <Grid.Column width={6}><Input name='rapport_2_3_a_q' formEntry={equipment} label='A/+' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_q' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>R</Grid.Column>
              <Grid.Column width={7}>Après la fin des essais, consigner la tension aux bornes de la batterie (tension)</Grid.Column>
              <Grid.Column width={6}><Input name='rapport_2_3_yes_r' formEntry={equipment} label='V.c.c.' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_r' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>S</Grid.Column>
              <Grid.Column width={7}>Après les essais, la tension de batterie n'est pas inférieure à 85% de la tension nominale</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_s' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_s' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>T</Grid.Column>
              <Grid.Column width={7}>Le générateur fournit l'alimentation au circuit c.a. qui dessert le réseau avertisseur d'incendie</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_t' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_t' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>U</Grid.Column>
              <Grid.Column width={7}>Une situation de défectuosité au générateur d'urgence doit provoquer un signal de défectuosité sonore commun ainsi qu'une indication visuelle sur l'annonciateur correspondant</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_yes_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_na_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_no_u' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_3_note_u' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.4 Mise à l'essai du circuit du dispositif auxiliaire <small>(Ref. art. 5.2.2 1-Z)</small></Header>)}>
          <p><strong>Consigner le type particulier de circuit du dispositif auxiliaire (Confirmation du fonctionnement du circuit du dispositif auxiliaire)</strong></p>
          <p>Note : Les essais indiqués sur ce formulaire ne comprennent pas l'essai de fonctionnement des dispositifs auxiliaires.</p>
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableRows'
            minimumRows={11}
            addRowLabel='Ajouter X nombre de lignes supplémentaires'
            droppableKey='tableEquipment'
            headers={[{
              props: { colSpan: 2, style: { width: '60%' } },
              key: 'resume',
              label: 'RÉSUMÉ'
            }, {
              props: { style: { width: '12%' } },
              key: 'oui',
              label: 'OUI'
            }, {
              props: { style: { width: '12%' } },
              key: 'na',
              label: 'N/A'
            }, {
              props: { style: { width: '12%' } },
              key: 'non',
              label: 'NON'
            }, {
              props: { style: { width: '12%' } },
              key: 'note',
              label: 'Note'
            }
            ]}
            fields={[
              {
                fieldType: Input,
                cellProps: { style: { width: '10%' } },
                props: {
                  name: 'rapport_2_4_letter_'
                }
              }, {
                fieldType: Input,
                cellProps: { style: { width: '40%' } },
                props: {
                  name: 'rapport_2_4_description_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rapport_2_4_yes_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rapport_2_4_na_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rapport_2_4_no_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'rapport_2_4_note_'
                }
              }
            ]}
          />
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.5 État des diverses fonctions</Header>)}>
          <Form.Group widths='equal'>
            <Input name='rapport_2_5_fabriquantReseau' formEntry={equipment} label='Fabricant du réseau' />
            <Input name='rapport_2_5_modele' formEntry={equipment} label='Modèle' />
          </Form.Group>
          <Grid>
            <Grid.Row columns='equal'>
              <Grid.Column verticalAlign='middle'>Type de déclencheur</Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_5_declencheur_electrique' formEntry={equipment} label='Électrique' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_5_declencheur_pneumatique' formEntry={equipment} label='Pneumatique' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_5_declencheur_explosif' formEntry={equipment} label='Explosif' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_5_declencheur_mecanique' formEntry={equipment} label='Mécanique' /></Grid.Column>
              <Grid.Column><Input name='rapport_2_5_declencheur_date' formEntry={equipment} label='Date' /></Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>Le panneau est homologué pour relâche incendie?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>Les cylindres sont homologués DOT ou TC?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={13}><Input name='rapport_2_5_text_c' formEntry={equipment} label='Type de relâche de système et délais avant éjection' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={13}>
                <Form.Group widths='equal'>
                  <Input name='rapport_2_5_zoneCroisee_d' formEntry={equipment} label='Zones croisées (s)' />
                  <Input name='rapport_2_5_zoneRelache_d' formEntry={equipment} label='Zones relâche simple (s)' />
                  <Input name='rapport_2_5_zoneMecanique_d' formEntry={equipment} label='Délai mécanique (s)' />
                </Form.Group>
              </Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_d' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>Le système a déclenché?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_e' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_e' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>La température ambiante de la pièce est acceptable?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_f' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_f' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>Le rétrotec a été effectué?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_g' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_g' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1} />
              <Grid.Column width={7}>La buse est libre de tout obstacle?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_yes_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_na_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_no_h' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_5_note_h' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.5 État des diverses fonctions</Header>)}>
          <Grid celled>
            <Grid.Row>
              <Grid.Column width={2}><Header as='h5'>Qté</Header></Grid.Column>
              <Grid.Column width={3}><Header as='h5'>Dispositif</Header></Grid.Column>
              <Grid.Column width={5}><Header as='h5'>Description</Header></Grid.Column>
              <Grid.Column width={3}><Header as='h5'>Manufacturier</Header></Grid.Column>
              <Grid.Column width={3}><Header as='h5'>No de modèle</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur manuel d'incendie <strong>(1 étape)</strong></Grid.Column>
              <Grid.Column width={3}><Input name='man_1' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_1' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur manuel d'incendie <strong>(2 étapes)</strong></Grid.Column>
              <Grid.Column width={3}><Input name='man_2' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_2' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de chaleur réarmable</Grid.Column>
              <Grid.Column width={3}><Input name='man_3' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_3' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de chaleur non réarmable</Grid.Column>
              <Grid.Column width={3}><Input name='man_4' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_4' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de chaleur non réarmable</Grid.Column>
              <Grid.Column width={3}><Input name='man_5' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_5' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de fumée</Grid.Column>
              <Grid.Column width={3}><Input name='man_6' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_6' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de fumée</Grid.Column>
              <Grid.Column width={3}><Input name='man_7' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_7' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_8' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_8' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de fumée</Grid.Column>
              <Grid.Column width={3}><Input name='man_8' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_8' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_9' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_9' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de fumée</Grid.Column>
              <Grid.Column width={3}><Input name='man_9' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_9' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_10' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_10' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Indicateur à distance</Grid.Column>
              <Grid.Column width={3}><Input name='man_10' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_10' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_11' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_11' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Détecteur de fumée de conduit</Grid.Column>
              <Grid.Column width={3}><Input name='man_11' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_11' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_12' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_12' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif d'appui (surveillance) (simple)</Grid.Column>
              <Grid.Column width={3}><Input name='man_12' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_12' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_13' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_13' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif d'appui (surveillance) (simple)</Grid.Column>
              <Grid.Column width={3}><Input name='man_13' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_13' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_14' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_14' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Solénoïde</Grid.Column>
              <Grid.Column width={3}><Input name='man_14' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_14' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_15' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_15' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Interrupteur de décharge à pression</Grid.Column>
              <Grid.Column width={3}><Input name='man_15' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_15' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_16' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_16' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Station d'avortement</Grid.Column>
              <Grid.Column width={3}><Input name='man_16' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_16' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_17' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_17' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif de surveillance de pression</Grid.Column>
              <Grid.Column width={3}><Input name='man_17' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_17' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_18' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_18' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Cloche</Grid.Column>
              <Grid.Column width={3}><Input name='man_18' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_18' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_19' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_19' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Cloche</Grid.Column>
              <Grid.Column width={3}><Input name='man_19' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_19' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_20' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_20' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur sonore</Grid.Column>
              <Grid.Column width={3}><Input name='man_20' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_20' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_21' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_21' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur sonore</Grid.Column>
              <Grid.Column width={3}><Input name='man_21' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_21' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_22' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_22' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif de signalisation visuelle</Grid.Column>
              <Grid.Column width={3}><Input name='man_22' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_22' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_23' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_23' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur sonore et visuel</Grid.Column>
              <Grid.Column width={3}><Input name='man_23' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_23' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_24' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_24' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur sonore et visuel</Grid.Column>
              <Grid.Column width={3}><Input name='man_24' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_24' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_25' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_25' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Avertisseur sonore et visuel</Grid.Column>
              <Grid.Column width={3}><Input name='man_25' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_25' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_26' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_26' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Haut-parleur à cône</Grid.Column>
              <Grid.Column width={3}><Input name='man_26' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_26' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_27' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_27' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif auxiliaire (simple)</Grid.Column>
              <Grid.Column width={3}><Input name='man_27' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_27' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_28' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_28' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Dispositif auxiliaire <strong>(6 sorties)</strong></Grid.Column>
              <Grid.Column width={3}><Input name='man_28' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_28' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_29' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_29' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Résistance d'extrémité de ligne</Grid.Column>
              <Grid.Column width={3}><Input name='man_29' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_29' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='qty_30' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='dis_30' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={5}>Contact du panneau incendie</Grid.Column>
              <Grid.Column width={3}><Input name='man_30' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={3}><Input name='noMo_30' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='sousTotalSignalisation' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={14}><Header as='h5'>Sous-total signalisation</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}><Input name='totalEquipment' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={14}><Header as='h5'>Total complet des dispositifs</Header></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>FICHE DES DISPOSITIFS</Header>)}>
          <Table celled>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Header as='h5'>A</Header></Table.Cell>
                <Table.Cell>Installation conforme</Table.Cell>
                <Table.Cell><Header as='h5'>E</Header></Table.Cell>
                <Table.Cell>Indication de l'annonce confirmée au PAI principal et à l'annonciateur à distance</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>B</Header></Table.Cell>
                <Table.Cell>Surveillance du câblage du dispositif confirmé</Table.Cell>
                <Table.Cell><Header as='h5'>F</Header></Table.Cell>
                <Table.Cell>Fonctionnement confirmé (relais, isolateurs, bouton silence)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>C</Header></Table.Cell>
                <Table.Cell>Fonctionnement de la supervision confirmé</Table.Cell>
                <Table.Cell><Header as='h5'>G</Header></Table.Cell>
                <Table.Cell>Nécessite entretien, réparations, nettoyage ou manquant. (Voir la page des Notes)</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>D</Header></Table.Cell>
                <Table.Cell>Fonctionnement de l'alarme confirmé</Table.Cell>
                <Table.Cell />
                <Table.Cell />
              </Table.Row>
            </Table.Body>
          </Table>
          <TableDnD
            formEntry={equipment}
            tableProps={{ celled: true, compact: 'very', size: 'small', style: { minWidth: '800px!important' } }}
            totalRowLabel='tableFicheDispositif'
            minimumRows={31}
            addRowLabel='Ajouter X nombre de fiches supplémentaires'
            droppableKey='tableFicheDispositif'
            headers={[{
              props: { style: { width: '350px' } },
              key: 'address',
              label: 'Adresse'
            }, {
              props: { style: { width: '150px' } },
              key: 'zone',
              label: 'Zone'
            }, {
              props: { style: { width: '150px' } },
              key: 'dispositif',
              label: 'Dispositif'
            }, {
              props: { },
              key: 'emplacement',
              label: 'Emplacement'
            }, {
              props: { style: { width: '30px' } },
              key: 'a',
              label: 'A'
            }, {
              props: { style: { width: '30px' } },
              key: 'b',
              label: 'B'
            }, {
              props: { style: { width: '30px' } },
              key: 'c',
              label: 'C'
            }, {
              props: { style: { width: '30px' } },
              key: 'd',
              label: 'D'
            }, {
              props: { style: { width: '30px' } },
              key: 'e',
              label: 'E'
            }, {
              props: { style: { width: '30px' } },
              key: 'f',
              label: 'F'
            }, {
              props: { style: { width: '30px' } },
              key: 'g',
              label: 'G'
            }
            ]}
            fields={[
              {
                fieldType: Input,
                props: {
                  name: 'addr_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'zone_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'dis_'
                }
              }, {
                fieldType: Input,
                props: {
                  name: 'emp_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'a_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'b_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'c_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'd_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'e_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'f_'
                }
              }, {
                fieldType: Checkbox,
                props: {
                  name: 'g_'
                }
              }
            ]}
          />
        </Section>
        <Section title={(<Header as='h2'>SYSTÈME AU GAZ<br />Section GAZ-2.6 Identification et vérification visuelle</Header>)}>

          <Grid>
            <Grid.Row>
              <Grid.Column><Input name='rapport_2_6_noSysteme' formEntry={equipment} label='No du système' /></Grid.Column>
            </Grid.Row>
            <Grid.Row columns='equal'>
              <Grid.Column verticalAlign='middle'><strong>Type de gaz</strong></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_6_halon' formEntry={equipment} label='Halon' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_6_co2' formEntry={equipment} label='CO2' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_6_inergen' formEntry={equipment} label='Inergen' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_6_fm200' formEntry={equipment} label='FM 200' /></Grid.Column>
              <Grid.Column verticalAlign='middle'><Checkbox name='rapport_2_6_novec' formEntry={equipment} label='Novec' /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column><Input name='rapport_2_6_autre' formEntry={equipment} label='Autre' /></Grid.Column>
            </Grid.Row>
          </Grid>

          <Grid celled>
            <Grid.Row>
              <Grid.Column width={8}><Header as='h5'>RÉSUMÉ</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>OUI</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>N/A</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>NON</Header></Grid.Column>
              <Grid.Column width={2}><Header as='h5'>Note</Header></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>261</Grid.Column>
              <Grid.Column width={7}><Input name='rapport_2_6_yes_zone' formEntry={equipment} label='Zone protégée' /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_yes_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_na_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_no_a' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_note_a' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>262</Grid.Column>
              <Grid.Column width={7}>Une inspection visuelle et mécanique de l'aire protégée a été effectuée?</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_yes_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_na_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_no_b' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_note_b' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={1}>263</Grid.Column>
              <Grid.Column width={7}>Les supports à tuyauterie et les supports sismiques sont en bon état? (pas de signes de corrosion ou de dommages)</Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_yes_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_na_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_no_c' formEntry={equipment} /></Grid.Column>
              <Grid.Column width={2}><Checkbox name='rapport_2_6_note_c' formEntry={equipment} /></Grid.Column>
            </Grid.Row>
          </Grid>
        </Section>
        <Section title={(<Header as='h2'>Section GAZ-2.7 Inventaire des cylindres</Header>)}>
          <Table celled className='full-compact'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Maître réserve</Table.HeaderCell>
                <Table.HeaderCell>Fabricant</Table.HeaderCell>
                <Table.HeaderCell>Date fabrication</Table.HeaderCell>
                <Table.HeaderCell>Test hydro</Table.HeaderCell>
                <Table.HeaderCell style={{ width: '200px' }}>No série</Table.HeaderCell>
                <Table.HeaderCell>Poids vide</Table.HeaderCell>
                <Table.HeaderCell>Poids plein</Table.HeaderCell>
                <Table.HeaderCell>Poids pesé</Table.HeaderCell>
                <Table.HeaderCell>Qté agent</Table.HeaderCell>
                <Table.HeaderCell>Pression psi ou bar</Table.HeaderCell>
                <Table.HeaderCell>Niveau liquide</Table.HeaderCell>
                <Table.HeaderCell>Dernier test hydro</Table.HeaderCell>
                <Table.HeaderCell>Inspection des boyaux d'activation (visuel seulement)</Table.HeaderCell>
                <Table.HeaderCell>Vérification mécanique tuyaux & supports (visuel seulement)</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {[...Array(13)].map((value, index) => (
                <Table.Row key={`cylindre_${index + 1}`}>
                  <Table.Cell><Input name={`rapport_2_7_maitre_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_fabricant_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_dateFabricant_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_testHydro_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_noSerie_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_poidVide_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_poidPlein_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_poidPese_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_qteAgent_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_pression_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_niveauLiquide_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_dernierTestHydro_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_inspection_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`rapport_2_7_verification_${index + 1}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>NOTES<br />Section N1 : Note au propriétaire (client) IMPORTANT</Header>)}>
          <p>Les hypothèses mentionnées ci-bas sont importantes pour notre rapport. Si vous êtes en désaccord avec l'une ou l'autre de ces hypothèses, il serait très important que vous contactiez notre département d'inspection afin de nous permettre de clarifier et d'évaluer les problèmes qui pourraient affecter de façon adverse vos systèmes.
            Ce présent rapport, à moins d'avis contraire de la part du client/propriétaire présume que les points suivants n'ont pas changé:
          </p>
          <Table celled>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Header as='h5'>N1.1</Header></Table.Cell>
                <Table.Cell>Il n'y a pas eu de changement dans la classification du bâtiment, les risques liés au contenu ou l'usage du bâtiment depuis la dernière inspection.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>N1.2</Header></Table.Cell>
                <Table.Cell>Il n'y a pas eu de modification au système de protection incendie, à l'architecture du bâtiment ou à la façon d'entreposer les matériaux depuis la dernière inspection.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>N1.3</Header></Table.Cell>
                <Table.Cell>Le système est demeuré en service sans modification depuis la dernière inspection.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>N1.4</Header></Table.Cell>
                <Table.Cell>Le système a été exempt d'alarme de feu ou de déclenchement des appareils de protection incendie depuis la dernière inspection.</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>N1.5</Header></Table.Cell>
                <Table.Cell>La bâtiment est chauffé afin de prévenir les dommages par le gel des systèmes sous eau (40°F/4.4°C) ou de partie d'autres systèmes sujet au gel.</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>Section N2 : Notes observées lors de l'inspection</Header>)}>
          <strong>Identification des types de notes</strong>
          <Table celled collapsing>
            <Table.Body>
              <Table.Row>
                <Table.Cell><Header as='h5'>DM</Header></Table.Cell>
                <Table.Cell>Déficience Majeure</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>D</Header></Table.Cell>
                <Table.Cell>Déficience</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>RC</Header></Table.Cell>
                <Table.Cell>Recommandation</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><Header as='h5'>RM</Header></Table.Cell>
                <Table.Cell>Remarque</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <p>Afin de vous donner de plus amples informations concernant la définition de ces types de notes, veuillez vous référer à la dernière page de ce présent rapport.</p>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell># Notes</Table.HeaderCell>
                <Table.HeaderCell colSpan={2}>Légende (# phrase)</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>
                <Table.HeaderCell>Photos #</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {[...Array(17)].map((value, index) => (
                <Table.Row key={`section_n2_${index + 1}`}>
                  <Table.Cell style={{ width: '100px' }}><Input name={`notes_2_notes_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell style={{ width: '100px' }}><Input name={`notes_2_legende1_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell style={{ width: '100px' }}><Input name={`notes_2_legende2_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell><Input name={`notes_2_description_${index + 1}`} formEntry={equipment} /></Table.Cell>
                  <Table.Cell style={{ width: '160px' }}><Input name={`notes_2_photo_${index + 1}`} formEntry={equipment} /></Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Section>
        <Section title={(<Header as='h2'>Légende</Header>)}>
          <Header as='h4'>DÉFICIENCES MAJEURES: "DM"</Header>
          <p>
            Tout bris, disfonctionnement et/ou tout autre situation qui rend le système non opérationnel et qui affecte directement la protection complète du bâtiment et/ou de ses occupants. Ce type de déficience doit être considéré comme très "URGENT".<br />
            Les correctifs doivent être effectués sans aucun délai. Notre technicien sur place vous avisera immédiatement de l'urgence de la situation dans but de rendre votre réseau de gicleurs opérationnel le plus rapidement possible, pour la sécurité des occupants à l'intérieur du bâtiment.
            De plus, aucun certificat ne sera émis, et ce tant et aussi longtemps que les correctifs des ''Déficiences Majeures'' n'auront pas été effectués à ce bâtiment, respectant les normes en vigueur.  Une lettre vous expliquant le type de déficience ainsi que les procédures concernant les rectifications à effectuer vous sera expédiée par télécopieur à vos bureaux sans délai.
          </p>
          <p>
            Note:
            Concernant ce type de déficiences, nous vous recommandons fortement une surveillance interne de l'immeuble, 24 heures sur 24.
          </p>
          <Divider className='thick' />
          <Header as='h4'>DÉFICIENCES: "D"</Header>
          <p>Tous bris, disfonctionnement et/ou tout autre problème concernant les équipements de votre système de gicleurs n'affectant aucunement le bon fonctionnement de votre réseau de gicleurs.</p>
          <List bulleted>
            <List.Item>Pièce défectueuse</List.Item>
            <List.Item>Pièce manquante</List.Item>
            <List.Item>Pièce ou équipement qui n'est pas approuvés et/ou conforme aux normes en vigueur</List.Item>
            <List.Item>Pièce ou équipement qui ne respecte pas les normes</List.Item>
            <List.Item>De l'équipement non inspecté ou endroit non visité lors de l'inspection</List.Item>
          </List>

          <Divider className='thick' />
          <Header as='h4'>RECOMMANDATIONS: "RC"</Header>
          <p>Un ajout et/ou une modification recommandé concernant votre système de gicleurs n'affectant aucunement le bon fonctionnement de votre réseau de gicleurs, tel que:</p>

          <List bulleted>
            <List.Item>Déficience tolérée ou acceptée par les autorités ayant juridiction telles que:  assureurs, service des incendies, l'établissement et/ou la mise à jour de nouvelle(s) norme(s)</List.Item>
            <List.Item>Déficience selon les codes en vigueur à ce jour, mais non en date de l'installation</List.Item>
            <List.Item>Une amélioration du système de protection incendie</List.Item>
            <List.Item>Une relocalisation d'équipement afin de faciliter et minimiser les coûts d'inspection</List.Item>
            <List.Item>Le remplacement de pièces ou équipement de façon préventive</List.Item>
          </List>
          <p>Les correctifs peuvent être effectués à l'intérieur d'un délai raisonnable.<br />
            Ce type de recommandation ne compromet aucunement la sécurité des gens à l'intérieur du bâtiment.<br />
            *  Les correctifs concernant ce type de note peuvent par contre, être recommandés et/ou exigés par les autorités ayant juridiction
          </p>
          <Divider className='thick' />
          <Header as='h4'>REMARQUES: "RM"</Header>
          <p>Ce type de note est de type informatif, par exemple:</p>
          <List bulleted>
            <List.Item>Au sujet d'un équipement ou d'un dispositif.</List.Item>
            <List.Item>La séquence d'opération d'un équipement ou du système de protection incendie (dans les cas d'inspection alarme incendie).</List.Item>
            <List.Item>La localisation d'un équipement ou autre</List.Item>
            <List.Item>Les impacts sur d'autres équipements lors de l'inspection</List.Item>
            <List.Item>Notes spécifiques à la bâtisse pouvant aider le prochain technicien</List.Item>
            <List.Item>Toute information de type informatif seulement, ne nécessitant aucune intervention technique (réparation ou autre) de notre part, pouvant aider le technicien.</List.Item>
          </List>
        </Section>
      </Form>
    )
  }
}

export default RIANVC000
